import { render, staticRenderFns } from "./buildDinamicos.vue?vue&type=template&id=0c7ea16e&scoped=true&"
import script from "./buildDinamicos.vue?vue&type=script&lang=js&"
export * from "./buildDinamicos.vue?vue&type=script&lang=js&"
import style0 from "./buildDinamicos.vue?vue&type=style&index=0&id=0c7ea16e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7ea16e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDivider,VIcon,VRow})
